/**
 * Mask configurations used in the [mask] directive for antennas.
 * Documentation: https://imask.js.org/guide.html
 */
export class AntennaMaskConfig {
    public static readonly gain = {
        mask: Number,
        scale: 1,
        signed: false,
        thousandsSeparator: '',
        padFractionalZeros: false,
        normalizeZeros: true,
        min: 0,
        max: 999.9,
        radix: '.',
        lazy: false,
    };

    public static readonly beamwidth = {
        mask: Number,
        scale: 1,
        signed: false,
        thousandsSeparator: '',
        padFractionalZeros: false,
        normalizeZeros: true,
        min: 0,
        max: 999.9,
        radix: '.',
        lazy: false,
    };

    public static readonly azimuth = {
        mask: Number,
        scale: 1,
        signed: false,
        thousandsSeparator: '',
        padFractionalZeros: false,
        normalizeZeros: true,
        min: 0,
        max: 360.0,
        radix: '.',
        lazy: false,
    };
}
